import React, { useEffect, useState } from 'react';
import { apiClient } from './contexts/AuthContext';
import { Button, message } from 'antd';

const TestApi = () => {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const testApiCall = async () => {
    setLoading(true);
    try {
      // 测试 API 调用，应该会自动带上 accessToken 请求头
      const res = await apiClient.post('/portal-server-prod/sys/enumconfig/v1/list', {
        tableName: 'LOGIN_ITEM',
        colName: 'LOGIN_ITEM'
      });
      setResponse(res.data);
      message.success('API 调用成功');
    } catch (error) {
      console.error('API Error:', error);
      message.error('API 调用失败: ' + (error.message || '未知错误'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // 显示当前存储的 accessToken
    const token = localStorage.getItem('accessToken');
    console.log('Stored accessToken:', token);
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>API 测试组件</h2>
      <p>此组件用于测试 apiClient 是否正确添加了 accessToken 请求头</p>
      <Button 
        type="primary" 
        onClick={testApiCall} 
        loading={loading}
      >
        测试 API 调用
      </Button>
      
      {response && (
        <div style={{ marginTop: 20 }}>
          <h3>响应数据:</h3>
          <pre>{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default TestApi;